
import isClient from '@/mixins/isClient'
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  name: 'PostPage',
  mixins: [ogPagesMixins, isClient],
  layout: 'clear',
  scrollToTop: true,
  async asyncData({ $axios, route, error }) {
    try {
      const { article, author, products, isAvailable } = await $axios.$get(
        `/article/${route.params.id}`
      )
      return {
        post: article,
        author,
        products,
        isAvailable,
      }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },

  data() {
    return {
      seoType: 'article',
      isShowMenu: false,
      post: null,
      author: null,
      products: [],
      isAvailable: true,
      readMore: {
        articles: null,
        countAllPublishedArticles: null,
      },
      readMoreLimit: 3,
      readMoreOffset: 0,
      readMoreCount: 0,
      readMoreRelevant: 'yes',
      alsoWrite: {
        articles: null,
        countAllPublishedArticles: null,
      },
      alsoWriteLimit: 3,
      alsoWriteOffset: 0,
      alsoWriteCount: 0,
    }
  },

  async fetch() {
    await Promise.all([this.fetchReadMore(), this.fetchAlsoWrite()])
    this.setView()
  },
  computed: {
    isAuthorPremium() {
      const author = this.post?.author
      const currentTariff = author.accounting?.currentTariff

      if (!currentTariff) {
        return false
      } else {
        return (
          currentTariff.name === 'PREMIUM' &&
          currentTariff.status &&
          this.$dayjs().isBetween(
            currentTariff.startDate,
            currentTariff.endDate
          )
        )
      }
    },
    isOnlyForAuth() {
      return (
        !this.isAuthorPremium &&
        (!this.thematicStreams || this.thematicStreams?.length === 0)
      )
    },
    additionalMeta() {
      return [
        {
          hid: 'article:published_time',
          property: 'article:published_time',
          content: this.post?.publishDate,
        },
        {
          hid: 'article:author',
          property: 'article:author',
          content: `https://megasreda.ru/${this.post?.author?.username}`,
        },
        {
          hid: 'author',
          name: 'author',
          content: this.authorName,
        },
      ]
    },
    seoImage() {
      return {
        url: this.post?.ogImg
          ? `https://img.megasreda.ru/optimize?src=${this.post?.ogImg}&size=1200&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/${this.post?._id}.jpg`,

        urlVk: this.post?.ogImgVk
          ? `https://img.megasreda.ru/optimize?src=${this.post?.ogImgVk}&size=1020&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/vk/${this.post?._id}.jpg`,

        urlTw: this.post?.ogImg
          ? `https://img.megasreda.ru/optimize?src=${this.post?.ogImg}&size=1200&format=jpeg`
          : `https://api.megasreda.ru/image/ogimage/${this.post?._id}.jpg`,

        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    thematicStreams() {
      return this.post.streams.filter((stream) => stream.type === 'THEMATIC')
    },
    seoTitle() {
      let materialTitle = this.post?.title ? this.post.title : this.preText

      materialTitle = materialTitle?.replace(/<(.|\n)*?>/g, '')

      const subText = `| ${this.authorName} (@${this.author.username}) | Мегасреда | ${this.publishDateFormat}`

      return `${materialTitle} ${subText}`
    },
    publishDateFormat() {
      const date = new Date(this.post.publishDate)
      const dd = ('0' + String(date.getDate())).slice(-2)
      const MM = ('0' + String(date.getMonth() + 1)).slice(-2)
      const yy = ('0' + String(date.getFullYear() % 100)).slice(-2)
      const hh = ('0' + String(date.getHours())).slice(-2)
      const mm = ('0' + String(date.getMinutes())).slice(-2)
      const ss = ('0' + String(date.getSeconds())).slice(-2)

      return `${dd}.${MM}.${yy}, ${hh}:${mm}:${ss}`
    },
    seoDescription() {
      if (this.post?.description) {
        return `${
          this.post.description
        }... - читайте подробнее в материале от ${
          this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
        } ${this.authorName} (@${this.author.username}) опубликованном ${
          this.publishDateFormat
        }`
      } else {
        const text = this.post?.text
        if (text?.blocks?.length) {
          const paragrafs = text?.blocks.filter(
            (block) => block.type === 'paragraph'
          )

          if (paragrafs?.length > 2) {
            const sanitizeText = paragrafs[1]?.data?.text.replace(
              /<(.|\n)*?>/g,
              ''
            ) // Вырезаем все теги из текста
            return `${sanitizeText.slice(
              0,
              280
            )}... - читайте подробнее в материале от ${
              this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
            } ${this.authorName} (@${this.author.username}) опубликованном ${
              this.publishDateFormat
            }`
          } else if (paragrafs?.length !== 0) {
            const sanitizeText = paragrafs[0]?.data?.text.replace(
              /<(.|\n)*?>/g,
              ''
            ) // Вырезаем все теги из текста

            return `${sanitizeText.slice(
              0,
              280
            )}... - читайте подробнее в материале от ${
              this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
            } ${this.authorName} (@${this.author.username}) опубликованном ${
              this.publishDateFormat
            }`
          } else {
            return `Читайте подробнее в материале от ${
              this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
            } ${this.authorName} (@${this.author.username}) опубликованном ${
              this.publishDateFormat
            }`
          }
        }
        return `Читайте подробнее в материале от ${
          this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
        } ${this.authorName} (@${this.author.username}) опубликованном ${
          this.publishDateFormat
        }`
      }
    },
    shareTitle() {
      if (this.post.title) {
        return this.post.title
      } else if (this.post?.text) {
        const text = this.post.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
    shareDescription() {
      if (this.post.description) {
        return this.post.description
      } else if (this.post?.text) {
        const text = this.post.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 3).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },

    isAuthor() {
      if (this.post?.author?._id) {
        return this.$auth?.user?._id === this.post?.author._id
      } else {
        return false
      }
    },
    telegramChannel() {
      const channelLinkArr = this.post.source.split('/')
      const channel = channelLinkArr[channelLinkArr.length - 1]
      return `@${channel}`
    },
    authorName() {
      if (this.post?.author?.type === 'COMPANY') {
        return this.post?.author.company.title
          ? this.post?.author?.company?.title
          : this.post?.author?.username
      } else {
        return this.post?.author?.profile?.firstName &&
          this.post?.author?.profile?.lastName
          ? `${this.post?.author?.profile?.firstName} ${this.post?.author?.profile?.lastName}`
          : this.post?.author?.username
      }
    },
    authorPhone() {
      if (this.post?.author?.type === 'COMPANY') {
        return this.post?.author?.company?.contacts?.phone
          ? this.post.author.company.contacts.phone
          : ' '
      } else {
        return this.post?.author?.profile?.contacts?.phone
          ? this.post.author.profile.contacts.phone
          : ' '
      }
    },
    authorEmail() {
      if (this.post?.author?.type === 'COMPANY') {
        return this.post?.author?.company?.contacts?.email
          ? this.post.author.company.contacts.email
          : ' '
      } else {
        return this.post?.author?.profile?.contacts?.email
          ? this.post.author.profile.contacts.email
          : ' '
      }
    },
    authorWebsite() {
      if (this.post?.author?.type === 'COMPANY') {
        return this.post?.author?.company?.contacts?.website
          ? this.post.author.company.contacts.website
          : ' '
      } else {
        return this.post?.author?.profile?.contacts?.website
          ? this.post.author.profile.contacts.website
          : ' '
      }
    },
    preText() {
      if (this.post?.text) {
        const text = this.post.text
        if (text?.blocks?.length) {
          const preText = text.blocks.find(
            (block) => block.type === 'paragraph'
          )
          const sanitizeText = preText?.data?.text.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        } else {
          return this.post?.description
        }
      }
      return null
    },
  },

  created() {
    if (process?.client) {
      this.$eventBus.$on('updateSubscriptions', async () => {
        await this.fetchPost()
      })
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('updateSubscriptions')
  },
  methods: {
    updateReadMorePost() {
      this.readMore.articles = []
      this.fetchReadMore()
    },
    getPostEntity(type) {
      switch (type) {
        case 'article':
          return 'Статья'
        case 'video':
          return 'Видео'
        case 'telegram':
          return 'Материал'

        default:
          return 'Материал'
      }
    },
    isTelegram(article) {
      return article.type === 'telegram'
    },
    loadReadMore() {
      this.readMoreOffset = this.readMoreOffset + this.readMoreLimit
      this.fetchReadMore()
    },
    loadAlsoWrite() {
      this.alsoWriteOffset = this.alsoWriteOffset + this.alsoWriteLimit
      this.fetchAlsoWrite()
    },
    setView() {
      this.$axios.$post('/activity/view/article', {
        username: this.author?.username,
        articleId: this.post._id,
      })
    },

    async fetchPost() {
      const { article, author, products, isAvailable } = await this.$axios.$get(
        `/article/${this.$route.params.id}`
      )
      this.post = article
      this.author = author
      this.products = products
      this.isAvailable = isAvailable
    },

    async fetchReadMore() {
      const readMore = await this.$axios.$get('/articles/read_more', {
        params: {
          article: this.post._id,
          relevants: this.readMoreRelevant,
          limit: this.readMoreLimit,
          offset: this.readMoreOffset,
        },
      })

      this.readMoreCount = readMore.countAllPublishedArticles
      if (this.readMoreRelevant === 'yes' && readMore.relevants === 'no') {
        this.readMoreRelevant = readMore.relevants
        this.readMoreOffset = readMore.noRelevantsOffset - this.readMoreLimit
      }
      if (this.readMore?.articles?.length) {
        this.readMore.articles = this.readMore.articles.concat(
          readMore.articles
        )
      } else {
        this.readMore.articles = readMore.articles
      }
    },

    async fetchAlsoWrite() {
      const alsoWrite = await this.$axios.$get('/articles/also_write', {
        params: {
          article: this.post._id,
          limit: this.alsoWriteLimit,
          offset: this.alsoWriteOffset,
        },
      })

      this.alsoWriteCount = alsoWrite.countAllPublishedArticles
      if (this.alsoWrite?.articles?.length) {
        this.alsoWrite.articles = this.alsoWrite.articles.concat(
          alsoWrite.articles
        )
      } else {
        this.alsoWrite.articles = alsoWrite.articles
      }
    },

    closeMenu() {
      this.isShowMenu = false
    },
    removePost() {
      this.$router.push('/')
    },
  },
}
